module.exports = __webpack_public_path__ + "img/device_motog8_plus_front_100x100.9a2f0911.png";